import { ReactComponent as Logo } from "assets/footer/logo.svg"
// import { ReactComponent as Blog } from "assets/footer/blog.svg"
// import { ReactComponent as Insta } from "assets/footer/insta.svg"
// import { ReactComponent as X } from "assets/footer/x.svg"
import Container from "components/common/Container";

const Footer = () => {
    return (
        <footer className="flex flex-col justify-center items-center gap-17 mobile:gap-4 bg-[#ECEEF2] py-20 w-full text-[#4D4D4D] text-sm">
            <Container className="flex justify-between">
                <div className="flex flex-col mobile:items-center gap-3 mobile:gap-4 mobile:w-full">
                    <Logo />
                    <p>㈜디인사이트</p>
                    <p className="hover:text-primary hover:underline transition-all cursor-pointer">
                        이용문의 : <a href="mailto:inform@theinsight.co.kr" >inform@theinsight.co.kr</a>
                    </p>
                    <p className="hover:text-primary hover:underline transition-all cursor-pointer">
                        제휴문의 : <a href="mailto:biz@theinsight.co.kr" >biz@theinsight.co.kr</a>
                    </p>
                    <p>사업자등록번호: 529-86-02575 대표이사: 이승환</p>
                    <p>서울특별시 강남구 선릉로 86길 38, 7층 7345호(대치동)</p>
                </div>

                {/* <div className="flex gap-4.5">
                    <Blog className="cursor-pointer" />
                    <Insta className="cursor-pointer" />
                    <X className="cursor-pointer" />
                </div> */}
            </Container>
            <Container>
                <p className="w-3/5 mobile:w-full text-[#ADADAD] text-xs text-left mobile:text-center">Copyright &copy; 2025 Theinsight Co., Ltd. All Rights Reserved.</p>
            </Container>
        </footer>
    )
}

export default Footer